/* 会員登録バナーで使うクラスを変数に設定 */
var bottom = $('.member__bottom');
var bottomSp = $('.member__bottom--sp');
var logo = $('.member__logo');
var bubble = $('.member__bubble');
var close =$('.member__close');
var closeSp =$('.member__close--sp');

/* スクロールの制御 */
$(window).scroll(function(){
  if($(this).scrollTop() > 50) {
      bottom.addClass('member-scroll');
      bottomSp.addClass('member-scroll');
      bubble.delay(800).queue(function(next){
        $(this).addClass('opacity');
        next();
      });
  } else {
      bottom.removeClass('member-scroll');
      bottomSp.removeClass('member-scroll');
      bubble.removeClass('opacity');
  }
});

/* 閉じるボタンを押すとバナー自体が非表示になる。 */
close.click(function(){
  bottom.hide();
});
closeSp.click(function(){
  bottomSp.hide();
});